module.exports = __webpack_public_path__ + "static/media/5DPO8.429c616b.jpg";